// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.device

import org.multipaz.cbor.DataItem
import org.multipaz.device.DeviceAttestation
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.device.DeviceAttestationAndroid
import org.multipaz.device.DeviceAttestationIos
import org.multipaz.device.DeviceAttestationSoftware

fun DeviceAttestation.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "uyaB472Icx92XnZeQFt2QdbXMn6DpRAucJ6AS1-tr5M")
val DeviceAttestation_cborSchemaId = ByteString(-69, 38, -127, -29, -67, -120, 115, 31, 118, 94, 118, 94, 64, 91, 118, 65, -42, -41, 50, 126, -125, -91, 16, 46, 112, -98, -128, 75, 95, -83, -81, -109)

fun DeviceAttestation.Companion.fromCbor(data: ByteArray): DeviceAttestation {
    return DeviceAttestation.fromDataItem(Cbor.decode(data))
}

val DeviceAttestation.Companion.cborSchemaId: ByteString
    get() = DeviceAttestation_cborSchemaId

fun DeviceAttestation.toDataItem(): DataItem {
    return when (this) {
        is DeviceAttestationAndroid -> (this as DeviceAttestationAndroid).toDataItem()
        is DeviceAttestationIos -> (this as DeviceAttestationIos).toDataItem()
        is DeviceAttestationSoftware -> (this as DeviceAttestationSoftware).toDataItem()
    }
}

fun DeviceAttestation.Companion.fromDataItem(dataItem: DataItem): DeviceAttestation {
    val type = dataItem["type"].asTstr
    return when (type) {
        "Android" -> DeviceAttestationAndroid_fromDataItem(dataItem)
        "Ios" -> DeviceAttestationIos.fromDataItem(dataItem)
        "Software" -> DeviceAttestationSoftware.fromDataItem(dataItem)
        else -> throw IllegalArgumentException("wrong type: $type")
    }
}
